import React, { useEffect, useMemo, useRef, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import i18n from "src/i18n";

import EerrDetail from "./formTypes/eerrDetail/eerrDetail";
import CashPositionDetail from "../../dashboard/PosicionCaja/CashPositionDetail";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Form from "./Form";
import AreaDetail from "../../flujocaja/areaDetail";
import InitialBalance from "../../flujocaja/initialBalance";

import { importForms } from "../../../redux/actions/ui";
import { importDisplayDetail } from "../../../redux/actions/fcDetail";
import { importInitialBalanceSidebar } from "../../../redux/actions/initialBalance";
import { importManualDocument } from "../../../redux/actions/manualDocument";
import { importOpenSidebar } from "../../../redux/actions/openSidebar";
import { detailEERR } from "../../../redux/actions/eerr";
import { CCol } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import { getIconsByPage } from "./RightSideBarIcons";
import "../sass/rightsidebar.scss";
import DescargarLibro from "./forms/descargarLibro";
import { Popup, Label } from "semantic-ui-react";
import { Plans } from "src/utils/plans";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import CommentsTab from "src/components/documentostributarios/documentTypes/CommentsTab";
import RepositoryCommentsTab from "src/components/repositorio/RepositoryCommentsTab";
import FlowCommentsTab from "src/components/flujocaja/FlowCommentsTab";
import F29CommentsTab from "src/components/f29/F29CommentsTab";
import HaberesVariablesCommentsTab from "src/components/haberesVariables/HaberesVariablesCommentsTab";
import BitacoraPanel from "src/components/flujocaja/bitacora/BitacoraPanel";
import BitacoraHistoryList from "src/components/flujocaja/bitacora/BitacoraHistoryList";
import CobranzaGestionSidebar from "src/components/cobranza/CobranzaFacturas/CobranzaGestionSidebar";
import CobranzaGestionHistorySidebar from "src/components/cobranza/CobranzaFacturas/CobranzaGestionHistorySidebar";
import { UserContext } from "src/context";
import FeatherIcon from "feather-icons-react";
import { useBlockedFeatures } from "src/hooks/useBlockedFeatures";

const RightSidebar = ({
  page,
  pageForms = {},
  setMenuClosedIcons = [],
  closeMenuFunctions = {},
  setUpdate,
  updateFunction,
  iconsToHide = [],
  inputAgenda,
  setCheckedTransactions,
  hideWhenClosed = false,
  onFlowCommentsClick,
  onF29CommentsClick,
  onHvCommentsClick,
  hvCommentsCount = 0,
  onHvCommentCreated,
  onBitacoraClick,
  canSeeBitacora = true,
}) => {
  const { t } = useTranslation("finance");
  const { isCrearObligacionBlocked } = useBlockedFeatures();
  const [type, setType] = useState("iconComp");
  const matches = useMediaQuery("(max-width:480px)");
  const [selectedMenu, setSelectedMenu] = useState();
  const dispatch = useDispatch();
  const { forms } = useSelector((state) => state.ui);
  const { selectedCompany } = useSelector((state) => state.companyList);
  const { displayDetail } = useSelector((state) => state.fcDetail);
  const { openSidebar } = useSelector((state) => state.openSidebar);
  const { initialBalance } = useSelector((state) => state.initialBalance);
  const { detailEerr } = useSelector((state) => state.eerr);
  const { enhanced } = useSelector((state) => state.enhanced);
  const { documentsFilter = {} } = useSelector(
    (state) => state.documentostributarios
  );
  const auth = useSelector((state) => state.auth);
  const userInfo = useContext(UserContext);

  const title = pageForms[type] ? pageForms[type].title : null;
  const form = pageForms[type] ? pageForms[type].form : null;
  const options = pageForms[type] ? pageForms[type].options : null;

  const isFirstRender = useRef(true);
  const lastTopRouteRef = useRef(null);

  useEffect(() => {
    dispatch(importForms());
  }, [dispatch]);

  useEffect(() => {
    if (openSidebar?.editAgenda) {
      setType("editAgenda");
    }
    if (openSidebar?.fastObligationFC) {
      setType("iconAgregar2");
    }
    if (openSidebar?.fastObligation) {
      setType("fastObligation");
    }
    if (openSidebar?.createObligation) {
      setType("createObligation");
    }
    if (openSidebar?.concile) {
      setType("concile");
    }
    if (openSidebar?.editPassword) {
      setType("editPassword");
    }
    if (openSidebar?.editTaxDocument) {
      setType("editTaxDocument");
    }
    if (openSidebar?.editObligation) {
      setType("editObligation");
    }
    if (openSidebar?.editCredit) {
      setType("editCredit");
    }
    if (openSidebar?.paymentBox) {
      setType("paymentBox");
    }
    if (openSidebar?.importPaymentBox) {
      setType("importPaymentBox");
    }
    if (openSidebar?.newAgenda) {
      setType("newAgenda");
    }
    if (openSidebar?.historyView) {
      setType("historyView")
    } else if (openSidebar?.reconcile) {
      setType("reconcile");
    }
    if (openSidebar?.automationView) {
      setType("automationView")
    }
    if (openSidebar?.reconcile && openSidebar?.editData?.type === 'flow') {
      setType("flowComments");
    }
    if (openSidebar?.bitacora) {
      setType("bitacora");
    }
    if (openSidebar?.createConection) {
      setType("iconAgregar");
    }
    if (openSidebar?.areaDetail) {
      setType("areaDetail");
    }
    if (openSidebar?.editManualDocument) {
      setType("editManualDocument");
    }
    if (openSidebar?.initialBalance) {
      setType("initialBalance");
    }
    if (openSidebar?.createBalance) {
      setType("createBalance");
    }
    if (openSidebar?.eerrDetail) {
      setType("eerrDetail");
    }
    if (openSidebar?.eoafDownload) {
      setType("eoafDownload");
    }
    if (openSidebar?.cashPositionDetail) {
      setType("cashPositionDetail");
    }
    if (openSidebar?.fieldDetail) {
      setType("fieldDetail");
    }
    if (openSidebar?.iconDescarga2) {
      setType("iconDescarga2")
    }
    if (openSidebar?.acceptDocSii) {
      setType("acceptDocSii")
    }
    /*
      Asignar cuentas contables desde un reporte de gestión. Se abre desde el
      rail, desde la fila "Sin asignar" de la tabla y desde el aviso de la barra
      de filtros: esos dos últimos despachan la bandera en vez de tener que
      llegar al icono.
    */
    if (openSidebar?.unassignedAccounts) {
      setType("unassignedAccounts")
    }
  }, [openSidebar]);

  useEffect(() => {
    if (openSidebar?.show == false) {
      setSelectedMenu(undefined)
    }
  }, [openSidebar?.show])

  const showMenu = (item) => {
    if (
      isCrearObligacionBlocked() &&
      (item === "importObligations" || (item === "iconAgregar" && page === "flujocaja"))
    ) {
      return;
    }
    if (item === "eoafDownload") {
      dispatch(importOpenSidebar({ show: true, eoafDownload: true }));
      return;
    }
    const show = !setMenuClosedIcons.includes(item);
    setType(item);
    if (show) {
      // Pass the item/type so parent components can identify which icon was clicked
      dispatch(importOpenSidebar({ show, clickedItem: item }));
    }
    dispatch(importDisplayDetail({ show: false }));
    dispatch(importInitialBalanceSidebar({ showInitialSidebar: false }));
    dispatch(importManualDocument());

    if (!show && closeMenuFunctions) {
      if (item === "iconDescarga" && openSidebar.downloadBook) {
      } else {
        closeMenuFunctions[item]();
      }
    }
    if (setUpdate?.includes(item)) {
      dispatch(importOpenSidebar({ show: false }));
      updateFunction();
    }
    if (item === "addPersonaIcon") {
      dispatch(importOpenSidebar({ show: true, reIncludeProvider: true }));
    }
    if (item === "subidaIcon") {
      dispatch(importOpenSidebar({ show: true, importProvider: true }));
    }
    if (item === "descargaIcon") {
      dispatch(importOpenSidebar({ show: true, informProvider: true }));
    }
  };
  const history = useHistory();
  const location = useLocation();

  const closeMenu = () => {
    // Special case: on /repositorio, the history sidebar is tied to the /historial route.
    // If the user closes the sidebar while still on /historial, Repositorio will auto-open it again.
    // So when closing historyView on repositorio, also navigate back via the provided close handler.
    if (
      (page === "repositorio" || page === "tarjetasCredito" || page === "consolidadoF29") &&
      openSidebar?.historyView &&
      typeof closeMenuFunctions?.historyView === "function"
    ) {
      closeMenuFunctions.historyView();
    }
    // En flujocaja, la X en historial solo cierra el historial y vuelve a la bitácora (no cerrar todo el sidebar).
    if (
      page === "flujocaja" &&
      openSidebar?.historyView &&
      typeof closeMenuFunctions?.historyView === "function"
    ) {
      closeMenuFunctions.historyView();
      return;
    }

    setSelectedMenu();
    dispatch(
      importOpenSidebar({
        show: false,
        reIncludeProvider: false,
        importProvider: false,
        informProvider: false,
        newAgenda: false,
        editAgenda: false,
        editdata: null,
        eoafDownload: false,
        cobranzaGestion: false,
        cobranzaGestionHistoryView: false,
      })
    );

    dispatch(importDisplayDetail({ show: false }));
    dispatch(importInitialBalanceSidebar({ showInitialSidebar: false }));
    dispatch(importManualDocument());
    dispatch(detailEERR({ show: false }));

    if (typeof openSidebar.setSelectedTransactionId === 'function') {
      openSidebar.setSelectedTransactionId(null);
    }

    const currentParams = new URLSearchParams(location.search);
    currentParams.delete("id");
    currentParams.delete("isComment");
    currentParams.delete("transactionId");
    currentParams.delete("idAgenda");
    currentParams.delete("contactTab");
    history.replace({ search: currentParams.toString() });

    delete inputAgenda?.idAgenda;
    delete inputAgenda?.contactTab;
  };

  useEffect(() => {
    if (isFirstRender.current) {
      return;
    }
    closeMenu();
    setSelectedMenu();
  }, [selectedCompany]);

  // Close sidebar when page changes
  useEffect(() => {
    if (openSidebar?.show) {
      closeMenu();
      setSelectedMenu();
    }
  }, [page]);

  // Close sidebar on route/location changes
  useEffect(() => {
    // Close only when switching to a different top-level module route (e.g. /repositorio -> /transactions).
    // Do NOT close on internal route changes within a module (e.g. /repositorio/:section/:period -> /repositorio/:section/:period/historial),
    // because those routes intentionally use the sidebar.
    const topRoute = (location.pathname || "").split("/")[1] || "";
    if (lastTopRouteRef.current === null) {
      lastTopRouteRef.current = topRoute;
      return;
    }
    const changedTopRoute = topRoute !== lastTopRouteRef.current;
    lastTopRouteRef.current = topRoute;
    if (changedTopRoute && openSidebar?.show) {
      closeMenu();
      setSelectedMenu();
    }
  }, [location.pathname]);

  // Close sidebar on page refresh/load
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (openSidebar?.show) {
        closeMenu();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!openSidebar?.show) {
      setSelectedMenu();
    }
  }, [selectedMenu]);

  // Add ESC key listener to close sidebar
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && openSidebar?.show) {
        closeMenu();
      }
    };

    // Add event listener
    document.addEventListener('keydown', handleEscKey);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [openSidebar?.show]);

  const iconsForPage = getIconsByPage(page, selectedCompany).filter(iconItem => {
    if (page === "conciliacion" && iconItem.item === "clasificar") return false;
    if (isCrearObligacionBlocked()) {
      if (iconItem.item === "importObligations") return false;
      if (iconItem.item === "iconAgregar" && page === "flujocaja") return false;
    }
    // Hide "importObligations" icon for documentostributarios page unless we're on /obligaciones route
    if (iconItem.item === "importObligations" && page === "documentostributarios") {
      return location.pathname === "/obligaciones";
    }
    return !iconsToHide.includes(iconItem.item);
  });

  const getIconTooltip = (iconItem) => {
    if (iconItem.msg) return iconItem.msg;
    if (iconItem.msgKey) {
      return i18n.t(iconItem.msgKey, { ns: iconItem.msgNs || "finance" });
    }
    return "";
  };

  const handleRailIconClick = (item) => {
    if (item === "historyView" && page === "contratosProximosAVencer") {
      const isOpen = !!(openSidebar?.show && openSidebar?.historyView);
      dispatch(importOpenSidebar({
        show: !isOpen,
        historyView: !isOpen,
        reconcile: false,
        sidebarExpanded: false,
      }));
      setSelectedMenu(isOpen ? undefined : item);
      return;
    }
    if (item === "flowComments" && onFlowCommentsClick) {
      onFlowCommentsClick();
      setSelectedMenu(item);
      return;
    }
    if (item === "f29Comments" && onF29CommentsClick) {
      onF29CommentsClick();
      setSelectedMenu(item);
      return;
    }
    if (item === "hvComments" && onHvCommentsClick) {
      onHvCommentsClick();
      setSelectedMenu(item);
      return;
    }
    if (item === "bitacora" && onBitacoraClick) {
      onBitacoraClick();
      setSelectedMenu(item);
      return;
    }
    showMenu(item);
    setSelectedMenu(item);
  };
  
  // Don't render sidebar if there are no icons for this page
  // Exception: repositorio, tarjetasCredito, cobranza/f29 use sidebar without icon rail
  if (iconsForPage.length === 0 && page !== "repositorio" && page !== "tarjetasCredito" && page !== "cobranza" && page !== "f29" && page !== "consolidadoF29" && page !== "contratosProximosAVencer") {
    return null;
  }

  return (
    <>

      
      <div
        className={`${openSidebar?.show
          ? "showSideBar barExtends d-flex justify-content-end"
          : "hideSideBar bar d-flex justify-content-end"
          }`}
        style={{
          position: 'fixed',
          top: '55px', // Account for header height
          right: 0,
          height: 'calc(100vh - 60px)', // Subtract header height
          zIndex: 1010, // Lower than header (1020)
          width: openSidebar?.show
            ? (openSidebar?.sidebarExpanded || (openSidebar?.bitacora && openSidebar?.bitacoraExpanded) ? 'calc(100vw - 80px)' : '50vw')
            : (hideWhenClosed ? '0px' : '60px'),
          backgroundColor: 'white',
          boxShadow: openSidebar?.show ? '-2px 0 10px rgba(0, 0, 0, 0.1)' : 'none',
          transition: 'width 0.3s ease, opacity 0.3s ease',
          opacity: (hideWhenClosed && !openSidebar?.show) ? 0 : 1,
          pointerEvents: (hideWhenClosed && !openSidebar?.show) ? 'none' : 'auto',
          overflow: 'hidden'
        }}
      >
        <div
          className={`${openSidebar?.show
            ? "d-flex flex-column justify-content-start align-items-center leftB"
            : "d-flex flex-column justify-content-start align-items-center leftBExtends"
            }`}
          style={{
            height: '100%',
            padding: '20px 10px',
            display: (hideWhenClosed && !openSidebar?.show) ? 'none' : 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            overflowY: 'auto',
            overflowX: 'hidden',
            width: '80px'
          }}
        >
          {iconsForPage.map((iconItem, index) => {
            const { icon, item, showModal, iconComponent } = iconItem;
            const tooltip = getIconTooltip(iconItem);

            const height = "21px";
            const width = "21px";

            const renderIcon = () => {
              if (iconComponent) {
                return <FeatherIcon icon={iconComponent} size={21} strokeWidth={1.5} style={{ color: 'currentColor' }} />;
              }
              return <img style={{ height, width }} className="filterWhite" src={icon} alt="logo" />;
            };

            if (item == 'informProvider' && selectedCompany?.plan
              && !(selectedCompany.plan.includes(Plans.smartcfo) || selectedCompany.plan.includes(Plans.smartcfopro)
                || selectedCompany.plan.includes(Plans.smartcfofull))) return null

            if (index == 0) {
              return (
                <Popup
                  key={`${item}-${i18n.language}`}
                  content={tooltip}
                  position="left center"
                  inverted
                  trigger={
                    <button
                      onClick={() => handleRailIconClick(item)}
                      className={`${selectedMenu === item ? "selectedMenu" : ""
                        } sidebarMenu cursor-pointer d-flex justify-content-center align-items-center`}
                      key={index}
                      style={{
                        marginTop: index === 0 ? (matches ? "60px" : "20px") : "15px",
                        backgroundColor:
                          enhanced[page]?.icon === item ? "#c0c1c2" : "",
                        width: '100%',
                        height: '40px',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {
                        <div className="position-relative">
                          {item == "filterIcon" && false && (
                            <Label
                              circular
                              color="red"
                              size="mini"
                              empty
                              className="position-absolute filterIsUsed"
                            />
                          )}
                          {item === "hvComments" && hvCommentsCount > 0 && (
                            <span className="hvCommentsBadge">
                              {hvCommentsCount > 99 ? "99+" : hvCommentsCount}
                            </span>
                          )}
                          {renderIcon()}
                        </div>
                      }
                    </button>
                  }
                ></Popup>
              );
            } else {
              return (
                <Popup
                  key={`${item}-${i18n.language}`}
                  content={tooltip}
                  position="left center"
                  inverted
                  trigger={
                    <button
                      onClick={() => handleRailIconClick(item)}
                      className={`${selectedMenu === item ? "selectedMenu" : ""
                        } sidebarMenu cursor-pointer d-flex justify-content-center align-items-center`}
                      style={{
                        marginTop: "15px",
                        backgroundColor:
                          enhanced[page]?.icon === item ? "#c0c1c2" : "",
                        width: '100%',
                        height: '40px',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {showModal && page == "documentostributarios" ? (
                        <DescargarLibro
                          openSidebar={openSidebar}
                          trigger={
                            <img
                              style={{ height, width }}
                              className="filterWhite"
                              src={icon}
                              alt="logo"
                            />
                          }
                        />
                      ) : (
                        <div className="position-relative">
                          {item == "filterIcon" && false && (
                            <Label
                              circular
                              color="red"
                              size="mini"
                              empty
                              className="position-absolute filterIsUsed"
                            />
                          )}
                          {item === "hvComments" && hvCommentsCount > 0 && (
                            <span className="hvCommentsBadge">
                              {hvCommentsCount > 99 ? "99+" : hvCommentsCount}
                            </span>
                          )}
                          {renderIcon()}
                        </div>
                      )}
                    </button>
                  }
                ></Popup>
              );
            }
          })}
        </div>
        {openSidebar?.show &&
          (// (type === "iconAgregar" && page === "proveedores") || // Sidebar deshabilitado para proveedores
            page === "agenda" ||
            page === "creditos" ||
            page === "proveedores" ||
            page === "documentostributarios" ||
            page === "conexiones" ||
            page === "users" ||
            page === "flujocaja" ||
            page === "conciliacion" ||
            page === "eerr" ||
            page === "eoaf" ||
            page === "cuadratura" ||
            page === "cobranza" ||
            page === "repositorio" ||
            page === "tarjetasCredito" ||
            page === "dashboard" ||
            page === "auditor" ||
            page === "f29" ||
            page === "consolidadoF29" ||
            page === "planDeCuentas" ||
            page === "reportesGestion" ||
            page === "haberesVariables" ||
            page === "contratosProximosAVencer") && (
            <>
              {detailEerr?.show ? (
                <EerrDetail closeMenu={closeMenu} />
              ) : (page === "repositorio" || page === "tarjetasCredito" || page === "consolidadoF29" || page === "contratosProximosAVencer") && openSidebar?.historyView ? (
                // Render history view using Form component with HistoryWrapper
                <Form
                  title={title}
                  closeMenu={closeMenu}
                  forms={forms[page] ? forms[page].forms : []}
                  type={type}
                  options={openSidebar?.options || options}
                  SelectedForm={form}
                  editData={openSidebar?.editData}
                  setDataFunction={openSidebar.setSelectedTransactionId}
                  setCheckedTransactions={setCheckedTransactions}
                  onToggleExpand={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                  isExpanded={!!openSidebar?.sidebarExpanded}
                />
              ) : page === "flujocaja" && openSidebar?.historyView ? (
                // Historial de bitácora - misma estructura que bitacora-panel
                <div className="rightsidebar-content-panel">
                  <div className="rightsidebar-content-header">
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                      <button
                        type="button"
                        onClick={() => typeof closeMenuFunctions?.historyView === 'function' && closeMenuFunctions.historyView()}
                        className="rightsidebar-header-icon-btn"
                        title={t("sidebar.backToLog")}
                      >
                        <FeatherIcon icon="arrow-left" size={20} strokeWidth={2} />
                      </button>
                      <h3 className="rightsidebar-content-header-title" style={{ margin: 0 }}>{t("sidebar.history")}</h3>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                      <button
                        type="button"
                        onClick={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                        className="rightsidebar-header-icon-btn"
                        title={openSidebar?.sidebarExpanded ? t("sidebar.collapse") : t("sidebar.expand")}
                      >
                        <FeatherIcon icon={openSidebar?.sidebarExpanded ? "minimize-2" : "maximize-2"} size={20} strokeWidth={2} />
                      </button>
                      <button
                        type="button"
                        onClick={() => typeof closeMenuFunctions?.closeSidebar === 'function' ? closeMenuFunctions.closeSidebar() : closeMenu()}
                        className="rightsidebar-header-icon-btn cursor-pointer"
                        title={t("sidebar.closePanel")}
                      >
                        <FeatherIcon icon="x" size={20} strokeWidth={2} />
                      </button>
                    </div>
                  </div>
                  <div className="rightsidebar-content-body">
                    <BitacoraHistoryList bitacora={openSidebar?.editData?.bitacora} />
                  </div>
                </div>
              ) : page === "repositorio" && openSidebar?.reconcile && openSidebar?.editData?.type === 'repositoryPeriod' ? (
                // Render RepositoryCommentsTab - misma estructura que bitacora-panel
                <div className="rightsidebar-content-panel">
                  <div className="rightsidebar-content-header">
                    <h3 className="rightsidebar-content-header-title" style={{ margin: 0 }}>{t("sidebar.comments")}</h3>
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                      <button
                        type="button"
                        onClick={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                        className="rightsidebar-header-icon-btn"
                        title={openSidebar?.sidebarExpanded ? t("sidebar.collapse") : t("sidebar.expand")}
                      >
                        <FeatherIcon icon={openSidebar?.sidebarExpanded ? "minimize-2" : "maximize-2"} size={20} strokeWidth={2} />
                      </button>
                      <button type="button" onClick={closeMenu} className="rightsidebar-header-icon-btn cursor-pointer" title={t("sidebar.close")}>
                        <FeatherIcon icon="x" size={20} strokeWidth={2} />
                      </button>
                    </div>
                  </div>
                  <div className="rightsidebar-content-body">
                    <RepositoryCommentsTab 
                      data={openSidebar.editData} 
                      companyIdOverride={openSidebar.companyId || selectedCompany?.id}
                      onCommentCreated={openSidebar?.onCommentCreated}
                    />
                  </div>
                </div>
              ) : page === "flujocaja" && openSidebar?.reconcile && openSidebar?.editData?.type === 'flow' ? (
                // Render FlowCommentsTab - misma estructura que bitacora-panel
                <div className="rightsidebar-content-panel">
                  <div className="rightsidebar-content-header">
                    <h3 className="rightsidebar-content-header-title" style={{ margin: 0 }}>{t("sidebar.comments")}</h3>
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                      <button
                        type="button"
                        onClick={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                        className="rightsidebar-header-icon-btn"
                        title={openSidebar?.sidebarExpanded ? t("sidebar.collapse") : t("sidebar.expand")}
                      >
                        <FeatherIcon icon={openSidebar?.sidebarExpanded ? "minimize-2" : "maximize-2"} size={20} strokeWidth={2} />
                      </button>
                      <button type="button" onClick={closeMenu} className="rightsidebar-header-icon-btn cursor-pointer" title={t("sidebar.close")}>
                        <FeatherIcon icon="x" size={20} strokeWidth={2} />
                      </button>
                    </div>
                  </div>
                  <div className="rightsidebar-content-body">
                    <FlowCommentsTab 
                      editData={openSidebar.editData} 
                      companyIdOverride={openSidebar.companyId || selectedCompany?.id}
                    />
                  </div>
                </div>
              ) : (page === "f29" || page === "consolidadoF29") && openSidebar?.reconcile && openSidebar?.editData?.type === 'f29' ? (
                // Render F29CommentsTab - misma estructura que flujocaja
                <div className="rightsidebar-content-panel">
                  <div className="rightsidebar-content-header">
                    <h3 className="rightsidebar-content-header-title" style={{ margin: 0 }}>Comentarios</h3>
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                      <button
                        type="button"
                        onClick={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                        className="rightsidebar-header-icon-btn"
                        title={openSidebar?.sidebarExpanded ? "Contraer" : "Expandir"}
                      >
                        <FeatherIcon icon={openSidebar?.sidebarExpanded ? "minimize-2" : "maximize-2"} size={20} strokeWidth={2} />
                      </button>
                      <button type="button" onClick={closeMenu} className="rightsidebar-header-icon-btn cursor-pointer" title="Cerrar">
                        <FeatherIcon icon="x" size={20} strokeWidth={2} />
                      </button>
                    </div>
                  </div>
                  <div className="rightsidebar-content-body">
                    <F29CommentsTab
                      editData={openSidebar.editData}
                      companyIdOverride={openSidebar.companyId || selectedCompany?.id}
                    />
                  </div>
                </div>
              ) : page === "haberesVariables" && openSidebar?.reconcile && openSidebar?.editData?.type === "haberesVariables" ? (
                <div className="rightsidebar-content-panel">
                  <div className="rightsidebar-content-header">
                    <h3 className="rightsidebar-content-header-title" style={{ margin: 0 }}>Comentarios</h3>
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                      <button
                        type="button"
                        onClick={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                        className="rightsidebar-header-icon-btn"
                        title={openSidebar?.sidebarExpanded ? "Contraer" : "Expandir"}
                      >
                        <FeatherIcon icon={openSidebar?.sidebarExpanded ? "minimize-2" : "maximize-2"} size={20} strokeWidth={2} />
                      </button>
                      <button type="button" onClick={closeMenu} className="rightsidebar-header-icon-btn cursor-pointer" title="Cerrar">
                        <FeatherIcon icon="x" size={20} strokeWidth={2} />
                      </button>
                    </div>
                  </div>
                  <div className="rightsidebar-content-body">
                    <HaberesVariablesCommentsTab
                      editData={openSidebar.editData}
                      companyIdOverride={openSidebar.companyId || selectedCompany?.id}
                      onCommentCreatedCallback={onHvCommentCreated}
                    />
                  </div>
                </div>
              ) : page === "flujocaja" && openSidebar?.bitacora && canSeeBitacora ? (
                // Render BitacoraPanel (padding-left para que la barra de iconos no bloquee el contenedor)
                <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', paddingLeft: '24px' }}>
                  <BitacoraPanel
                    closeMenu={closeMenu}
                    companyId={openSidebar.companyId || selectedCompany?.id}
                    isExpanded={!!openSidebar?.bitacoraExpanded}
                    onToggleExpand={() => dispatch(importOpenSidebar({ ...openSidebar, bitacoraExpanded: !openSidebar?.bitacoraExpanded }))}
                    initialExpandedBitacoraId={openSidebar?.editData?.bitacora?.id}
                  />
                </div>
              ) : page === "cobranza" &&
                openSidebar?.cobranzaGestion &&
                openSidebar?.cobranzaGestionHistoryView ? (
                <CobranzaGestionHistorySidebar
                  openSidebar={openSidebar}
                  closeMenu={closeMenu}
                  closeMenuFunctions={closeMenuFunctions}
                  dispatch={dispatch}
                  importOpenSidebar={importOpenSidebar}
                  companyId={openSidebar.companyId || selectedCompany?.id}
                />
              ) : page === "cobranza" &&
                openSidebar?.show &&
                !openSidebar?.cobranzaGestion &&
                !openSidebar?.cobranzaGestionHistoryView ? (
                <div className="cf-cobranza-sidebar-empty" aria-hidden />
              ) : page === "cobranza" && openSidebar?.cobranzaGestion ? (
                <div
                  className="cf-cobranza-gestion-sidebar-wrap"
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <CobranzaGestionSidebar
                    closeMenu={closeMenu}
                    companyId={openSidebar.companyId || selectedCompany?.id}
                    row={openSidebar.editData?.row}
                    clientDocs={openSidebar.editData?.clientDocs || []}
                    reexecuteQuery={openSidebar.editData?.reexecuteQuery}
                    onOpenClienteInfo={openSidebar.editData?.onOpenClienteInfo}
                    onOpenHistory={() =>
                      dispatch(
                        importOpenSidebar({
                          ...openSidebar,
                          show: true,
                          cobranzaGestion: true,
                          cobranzaGestionHistoryView: true,
                        })
                      )
                    }
                    isExpanded={!!openSidebar?.sidebarExpanded}
                    onToggleExpand={() =>
                      dispatch(
                        importOpenSidebar({
                          ...openSidebar,
                          sidebarExpanded: !openSidebar?.sidebarExpanded,
                        })
                      )
                    }
                  />
                </div>
              ) : openSidebar?.cashPositionDetail ? (
                <Form
                  title="Documentos"
                  closeMenu={closeMenu}
                  forms={[]}
                  type={type}
                  options={openSidebar?.options || options}
                  SelectedForm={CashPositionDetail}
                  editData={openSidebar?.editData}
                  setDataFunction={openSidebar.setSelectedTransactionId}
                  setCheckedTransactions={setCheckedTransactions}
                  onToggleExpand={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                  isExpanded={!!openSidebar?.sidebarExpanded}
                />
              ) : (
                <Form
                  title={title}
                  panelClassName={type === "automationView" ? "email-plantillas-portal-sidebar" : ""}
                  closeMenu={closeMenu}
                  forms={forms[page] ? forms[page].forms : []}
                  type={type}
                  options={openSidebar?.options || options}
                  SelectedForm={form}
                  editData={
                    openSidebar?.editAgenda ||
                      openSidebar?.newAgenda ||
                      openSidebar?.editTaxDocument ||
                      openSidebar?.editPassword ||
                      openSidebar?.editCredit ||
                      openSidebar?.paymentBox ||
                      openSidebar?.importPaymentBox ||
                      openSidebar?.concile ||
                      openSidebar?.reconcile ||
                      openSidebar?.editObligation ||
                      openSidebar?.createObligation ||
                      openSidebar?.fastObligation ||
                      openSidebar?.fastObligationFC ||
                      openSidebar?.reIncludeProvider ||
                      openSidebar?.areaDetail ||
                      openSidebar?.initialBalance ||
                      openSidebar?.editManualDocument ||
                      openSidebar?.createBalance ||
                      openSidebar?.eerrDetail ||
                      openSidebar?.cashPositionDetail ||
                      openSidebar?.fieldDetail ||
                      openSidebar?.cuadraturaFilter ||
                      openSidebar?.acceptDocSii ||
                      openSidebar?.historyView ||
                      openSidebar?.automationView
                      ? openSidebar?.editData
                      : null
                  }
                  setDataFunction = {openSidebar.setSelectedTransactionId}
                  setCheckedTransactions={setCheckedTransactions}
                  onToggleExpand={() => dispatch(importOpenSidebar({ ...openSidebar, sidebarExpanded: !openSidebar?.sidebarExpanded }))}
                  isExpanded={!!openSidebar?.sidebarExpanded}
                />
              )}
            </>
          )}
      </div>
    </>
  );
};

export default RightSidebar;
